// @owners { team: patients-team }
import {
  ActionSheetContext,
  Button,
  Column,
  Description,
  H2,
  LgSpacing,
  SmSpacing,
  XxxlPadding,
} from '@alto/design-system';
import { SuggestEssentialsActionSheet } from '@alto/features';
import React, { useEffect, useMemo } from 'react';
import { useEssentialsSearch } from '~shared/features/essentials';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { Image } from '~web/features/essentials/primitives';

type Props = {
  readonly queryString?: string;
  readonly origin?: string;
  readonly facilityId?: number;
  readonly shipmentId?: number | null;
};

export const NoSearchResults = ({ queryString, origin, facilityId, shipmentId }: Props) => {
  const { setActiveActionSheet } = React.useContext(ActionSheetContext);
  const { description, title } = useEssentialsSearch({});
  const { trackEvent, trackPageView } = useAnalytics();
  const params = useMemo(
    () => ({
      query_string: queryString,
      shipment_id: shipmentId,
      facility_id: facilityId,
      origin,
    }),
    [facilityId, origin, queryString, shipmentId],
  );

  const handleSuggestItemsPress = () => {
    trackEvent({ event: EVENTS.ESSENTIALS__SEARCH_FEEDBACK_FORM_VIEWED, params });
    setActiveActionSheet(<SuggestEssentialsActionSheet params={params} />);
  };

  useEffect(() => {
    trackPageView({ event: EVENTS.ESSENTIALS__EMPTY_SEARCH_RESULTS_VIEWED, params });
  }, [params, trackPageView]);

  return (
    <XxxlPadding>
      <Column center>
        <Image
          src="https://assets.prod.alto.com/otc_categories/alert.png"
          alt="error icon"
          height="100px"
          width="100px"
        />
        <LgSpacing />
        <H2>{title}</H2>
        <SmSpacing />
        <Description center>{description}</Description>
        <LgSpacing />
        <Button
          type="secondary"
          onPress={handleSuggestItemsPress}
        >
          Suggest items
        </Button>
      </Column>
    </XxxlPadding>
  );
};
